export const ConditionalWrapper = ({
  condition,
  wrapper,
  elseWrapper = wrapChildren => wrapChildren,
  children,
}) => (condition ? wrapper(children) : elseWrapper(children))

export const isLocalLink = path => {
  return (
    path &&
    !path.startsWith("http://") &&
    !path.startsWith("https://") &&
    !path.startsWith("//")
  )
}

export const formDataEncode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

export const isSSR = () => {
  return typeof window === "undefined"
}

export const scrollToElement = element => {
  if (element) {
    element.scrollIntoView({ behavior: "smooth" })
  }
}

export const getFileNameFromPath = path => {
  return path.replace(/^.*[\\/]/, "")
}
